const pagesIndividualApprovalsEn = {
  category: {
    attendance: 'Attendance',
    contract: 'Contract',
    ga: 'GA',
    it: 'IT',
    labor: 'Labor'
  },
  columns: {
    approvalDeadline: 'Deadline',
    category: 'Category',
    requester: 'Requester',
    status: 'Status',
    submittedAt: 'Submitted',
    taskName: 'Approval Task'
  },
  drawer: {
    actions: {
      approve: 'Approve',
      reject: 'Reject',
      return: 'Return'
    },
    closeLabel: 'Close',
    deadline: 'Deadline: {{date}}',
    description: 'Review and approve the approval task',
    inApproval: 'In approval',
    notFound: 'Approval task not found',
    sections: {
      approvalFlow: 'Approval flow',
      formSummary: 'Form details',
      requester: 'Requester'
    },
    submittedAt: '{{date}} submitted',
    you: '(you)'
  },
  empty: {
    all: 'There are no approval tasks',
    completed: 'There are no approved tasks',
    in_progress: 'There are no approval tasks in approval flow',
    pending: 'There are no approval tasks to do',
    rejected: 'There are no rejected tasks'
  },
  pageTitle: 'Approval Tasks',
  status: {
    completed: 'Approved',
    in_progress: 'In approval flow',
    pending: 'To do',
    rejected: 'Rejected'
  },
  tabs: {
    all: 'All'
  }
};
export default pagesIndividualApprovalsEn;